/** This export is automatically generated */
export const isoNow = '2025-05-20T10:41:35.901Z';
